var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBox = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 64,
  height: 64,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.57 10.097a1 1 0 0 1 .86 0l21 10A1 1 0 0 1 54 21v22a1 1 0 0 1-.57.903l-21 10a1 1 0 0 1-.86 0l-21-10A1 1 0 0 1 10 43V21a1 1 0 0 1 .57-.903l21-10zm-3.792 4.02 18.667 8.75 4.18-1.89L32 12.107l-4.222 2.01zM52 22.55l-4.563 2.064V34.5a1 1 0 0 1-1.355.934l-3.218-1.225-3.488 4.873a1 1 0 0 1-1.813-.582v-9.419L33 31.145v20.271l19-9.047v-19.82zM31 51.416v-20.27L12 22.55v19.819l19 9.047zm-17.625-30.44L32 29.403l4.153-1.878L17.57 18.98l-4.195 1.998zm6.547-3.117 18.644 8.573 5.481-2.48-18.606-8.721-5.52 2.628zm25.515 7.66-5.874 2.657v7.21l2.124-2.968a1 1 0 0 1 1.169-.352l2.581.983v-7.53z",
  fill: "#A1A1A9"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.875 17.25 21.5 16l2.625-1.25 1.313-.625 21 9.844V34.5L42.5 33l-3.938 5.5V27.531l-21-9.656 1.313-.625z",
  className: "box_svg__ColoredSvgPath",
  fill: "#23B40C",
  fillOpacity: 0.15
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m25.434 13.019 22.003 10.314v12.618l-4.573-1.742-5.301 7.406V28.172l-22.36-10.281 10.231-4.872zm14.128 15.158v7.208l2.574-3.594 3.301 1.258v-7.53l-5.874 2.658zm4.485-4.224-5.481 2.48-18.644-8.574 5.519-2.628 18.606 8.722z",
  className: "box_svg__ColoredSvgPath",
  fill: "#23B40C"
})));
export default SvgBox;